<ng-template #content let-modal>
  <div class="modal-header" style="height: 50px; border: none;">
    <button type="button"  aria-label="Close" class="button-close close" (click)="closeModal()" style="border: none;">
      <span aria-hidden="true" style="    font-size: 30px;">
        &times;
      </span> </button>
  </div>
  <div class="modal-body px-3 pb-3 pt-0 text-center">
    <div style="justify-content: center;"> <img class="img-fluid" src="/assets/images/compose email/email.svg"
        alt="upload-file" width="126" height="101" style="margin-top: 29px" /> </div> <span
      class="upload-title hideUpload mt-1" id="uploadMessage" style="font-weight: 500; font-size: 24px">Upload
      Your File</span>
    <form class="mb-0">
      <div class="form-group"> <span class="d-block mt-3 mb-2" id="uploadMessage1"
          style="font-size: 16px; font-weight: 500; color: #000000;">Upload your
          file from your system</span>
          <img src="/assets/images/compose email/cloud.svg"
          style="position: relative;    left: 48px; width: 28px; height: 22.55px;" />

        <input class="btn btn-modal-dark hideUpload" type="button" title="Click here to upload document"
          id="loadFileXml" value="Browse" (click)="fileInput.click()" style="
              width: 180px;
              height: 48px;
              font-size: 18px;
              background-color: #08BA9C;
              color: white;
              font-size: 18px;
              font-weight: 600;
              padding-left: 53px;
              line-height: 21.78px;
            " />
        <input id="upload" (change)="uploadFileSaveRedirect($event)" data-name="upload-element" #fileInput
          accept=".txt,.doc,.docx,.pdf" type="file" style="display: none" />
      
      </div>
    </form>
    <hr class="mt-5 " />
    <div style="position: relative; text-align: center; margin-top: -30px"> <span style="
      background: white;
      padding: 2px 10px;
      font-size: 18px;
      font-weight: 500;
      position: relative;
      top: -4px;
            ">OR</span> </div>
    <div class="btn-div">
      <button class="dbox-upload   btns mb-5 hideUpload   mt-4" (click)="openDropboxChooser()"
        style="cursor: pointer; font-size: 18px; font-weight: 500; margin-top: 5px" id="newfundropbox"
        accept=".txt,.doc,.docx,.pdf">
   
          <app-icons-free-tools name="uploadDropboxIcon" />
          Dropbox </button>
      <button (click)="gDriveUpload()" class="gdrive-upload   btns  hideUpload mb-5 mt-4"
        accept=".txt,.doc,.docx,.pdf" style="cursor: pointer; font-size: 18px; font-weight: 500;margin-top: 5px">
        
        <app-icons-free-tools name="uploadGoogleDriveIcon" />
        Google Drive </button>
    </div>
  </div>


</ng-template>

<button class="btn btn-lg btn-outline-primary d-none" (click)="openModels(content)">
  Upload
</button>

<div
*ngIf="error"
class="backdrop"
style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000;">
</div>

<div
*ngIf="error"
class="content-div"
style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);          width: 468px;
height: 360px;
 background-color: white;z-index: 9999999999999999;;  border-radius: 4px; border: 1px solid #E3E3F0;">

<div class="text-center" style="    margin-top: 9%;">
  <app-icons-free-tools name="errorIcon" />

  <div style="    width: 323px;
   height: 64px;
   margin-left: 77px;">
    <p
     class="error mt-4"
     style="   font-size: 20px;
     font-weight: 500;
     line-height: 33.89px;
 ">
     {{ errorAlerts }}
   </p>
   </div>

  <button
    class="mt-4 butn-alert"
    (click)="closeErrorDiv()">Ok</button>
</div>
</div>


<div
*ngIf="success"
class="backdrop"
style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000;">
</div>


<div
*ngIf="success"
class="content-div"
style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);           width: 468px;
height: 360px; background-color: white;  z-index: 9999999999999999999999999;; border-radius: 4px;border: 1px solid #E3E3F0;">

<div class="text-center" style="    margin-top: 9%;">
<app-icons-free-tools name="successIcon" />

<p
  class="error mt-4"
  style="    font-size: 28px;
  font-weight: 500;
  line-height: 33.89px
;
;">
  {{ successAlert}}
</p>

<button
  class="mt-4 butn-alert"
  (click)="closeErrorDiv()">Ok</button>
</div>
</div>